import React, { createContext, useContext, useState } from 'react';

// POC DUMMY STATE - belum ada backend untuk KPI, jadi disimpan di sini
// supaya My Progress (employee) dan Employee Detail (manager) berbagi
// sumber data yang sama. KPI yang ditambah/dihapus di satu halaman akan
// langsung terlihat di halaman lainnya.
const initialKpis = [
  { id: 'kpi-1', title: 'Dokumen Program Selesai', unit: 'dokumen', target: 9 },
  { id: 'kpi-2', title: 'Simulasi Data Terlaksana', unit: 'sesi', target: 2 },
];

const KpiContext = createContext();

export const KpiProvider = ({ children }) => {
  const [kpis, setKpis] = useState(initialKpis);

  return (
    <KpiContext.Provider value={{ kpis, setKpis }}>
      {children}
    </KpiContext.Provider>
  );
};

export const useKpi = () => {
  const context = useContext(KpiContext);
  if (!context) {
    throw new Error('useKpi must be used within a KpiProvider');
  }
  return context;
};
